module.exports = __webpack_public_path__ + "img/UTECHO-4.e3f7da8c.jpg";